//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatTrueFalse } from '../../components/helpers.js'
import { createFieldConfig, Store } from '../../components/QSelectUtils'
import { axiosGet } from '../../axios/axios.js'
import { getEnumValues } from './ServiceObjectMaintenanceNote.js'
import { convertReportFromServer } from '../Report/Report.js'
import ItemsSearchField from '../../components/Field/ItemsSearchField.vue'
import FilesField from '../../components/File/FilesField.vue'
import ServiceObjectMaintenanceNoteOperations from './ServiceObjectMaintenanceNoteOperations.vue'
import ServiceObjectMaintenanceNotePhotosFromReport from './ServiceObjectMaintenanceNotePhotosFromReport.vue'

export default {
  components: {
    ItemsSearchField,
    FilesField,
    ServiceObjectMaintenanceNoteOperations
  },
  props: {
    record: {
      type: Object,
      required: true
    },
    sourceProps: {
      type: Object,
      default: function () {
        return null
      }
    },
    createMode: {
      type: Boolean,
      default: false
    },
    access: {
      type: Boolean,
      default: false
    },
    multipleCreate: {
      type: Boolean,
      default: false
    },
    multipleCreateServiceObjectIds: {
      type: Array,
      default: null
    }
  },
  data: function () {
    let serviceObjectSelectionDialogColumns = [
      {
        name: 'alias',
        label: 'Название',
        align: 'left',
        defaultWidth: 130,
        field: 'alias',
        sortable: true
      },
      {
        name: 'fvfComplexNumber',
        label: 'Номер комплекса',
        labelTable: 'Номер</br>комплекса',
        align: 'left',
        defaultWidth: 80,
        field: 'fvfComplexNumber',
        sortable: true
      },
      {
        name: 'typeAlias',
        label: 'Тип',
        align: 'left',
        defaultWidth: 40,
        field: 'typeAlias',
        sortable: true
      },
      {
        name: 'address',
        label: 'Адрес',
        align: 'left',
        defaultWidth: 600,
        field: 'address',
        sortable: true
      }
    ]
    if (this.sourceProps && this.sourceProps.serviceObjectType === 'stationMetro') {
      serviceObjectSelectionDialogColumns = serviceObjectSelectionDialogColumns.filter(col => col.name === 'name')
    }
    return {
      formatTrueFalse: formatTrueFalse,
      maintenanceNoteTypeFieldConfig: createFieldConfig({ allRecordsFn: this.getMaintenanceNoteTypes }),
      recordSourceFieldConfig: createFieldConfig({ allRecordsFn: this.getRecordSources }),
      serviceObjectSearchConfig: createFieldConfig(this.sourceProps && this.sourceProps.serviceObjectType === 'stationMetro'
        ? { allRecordsFn: this.getMetroCameras }
        : new Store({
          fullReadable: false,
          cached: true,
          proxy: {
            urlBase: '/service/delta/serviceobject/search',
            filterType: 'serviceObject',
            formId: 'serviceObjectMaintenanceNote'
          }
        })),
      serviceObjectSelectionDialogColumns: serviceObjectSelectionDialogColumns,

      reports: [],
      loadingReports: false
    }
  },
  computed: {
    fixed: function () {
      return this.record && this.record.operationHistory && !!this.record.operationHistory.find(operation => operation.commentType.key === 'fixed')
    },
    serviceObjectId: function () {
      if (this.sourceProps && this.sourceProps.serviceObjectType !== 'stationMetro') {
        return this.sourceProps.serviceObjectId
      } else if (this.record.serviceObject) {
        return this.record.serviceObject.id
      }
      return null
    },
    serviceObjectType: function () {
      if (this.sourceProps && this.sourceProps.serviceObjectType !== 'stationMetro') {
        return this.sourceProps.serviceObjectType
      } else if (this.record.serviceObject) {
        return this.record.serviceObject.type
      }
      return null
    },
    sourceReportId: function () {
      if (this.sourceProps && this.sourceProps.recordSource === 'requestReport') {
        return this.sourceProps.requestReportId
      } else if (this.record.sourceObject && this.record.sourceObject.type === 'requestReport') {
        return this.record.sourceObject.id
      }
      return null
    },
    addPhotoFromReportButtonLabel: function () {
      return `Выбрать из ${this.sourceProps && this.sourceProps.recordSource === 'requestReport' || this.record.sourceObject && this.record.sourceObject.type === 'requestReport' ? 'отчёта' : 'истории отчётов'}`
    }
  },
  watch: {
    sourceReportId: {
      handler: function (value) {
        if (value) {
          this.loadReports()
        }
      },
      immediate: true
    },
    serviceObjectId: {
      handler: function (value) {
        if (value) {
          this.loadReports()
        }
      },
      immediate: true
    }
  },
  methods: {
    onAddPhotoFromReport: function () {
      const dialog = this.$d.dialog(this).show({
        noWrap: true,
        maximizedOnNarrow: true,
        contentComponent: ServiceObjectMaintenanceNotePhotosFromReport,
        contentWidth: 800,
        persistent: true,
        contentProps: {
          reports: this.reports,
          category: this.record._filesGroup
        },
        componentHandlers: {
          save: (data) => {
            const filesToDelete = this.record._filesGroup.files.filter(file => file.document.selectedFromReport)
            filesToDelete.forEach(file => {
              this.record._filesGroup.deleteFile(file)
            })
            this.record._filesGroup.pushFiles(data.map(id => {
              return {
                url: '/service/delta/document/read?id=' + id,
                name: id + ', ' + new Date().toLocaleString(),
                id: id,
                selectedFromReport: true
              }
            }))
            dialog.hide()
          },
          cancel: () => {
            dialog.hide()
          }
        }
      })
    },

    loadReports: function () {
      this.loadingReports = true
      if (this.sourceReportId) {
        return axiosGet({
          url: '/service/delta/report/' + this.sourceReportId,
          onSuccess: (response) => {
            const report = convertReportFromServer(response.data.result, this.$store.getters.getUser)
            this.reports = [report]
          },
          onFailure: ''
        }).finally(() => {
          this.loadingReports = false
        })
      } else if (this.serviceObjectId) {
        const urlParams = new URLSearchParams()

        if (this.serviceObjectType) {
          urlParams.append('type', this.serviceObjectType)
        }

        urlParams.append('limit', 10000)

        urlParams.append('external', false)
        return axiosGet({
          url: '/service/delta/serviceobject/reportsHistory/' + this.serviceObjectId + '?' + urlParams.toString(),
          onSuccess: (response) => {
            const reportsRaw = response.data.result.reports
            const reports = []
            reportsRaw.forEach(reportRaw => {
              reports.push(convertReportFromServer(reportRaw, this.$store.getters.getUser))
            })
            this.reports = reports
          },
          onFailure: 'Ошибка получения истории отчётов по объекту обслуживания'
        }).finally(() => {
          this.loadingReports = false
        })
      }
    },
    getRecordSources: function () {
      return getEnumValues('recordSource')
    },
    getMaintenanceNoteTypes: function () {
      let url = '/service/delta/journal/serviceobjectmaintenancenotes/getMaintenanceNoteTypes'
      let serviceObjectId = null
      if (this.record.serviceObject && this.record.serviceObject.id) {
        serviceObjectId = this.record.serviceObject.id
      } else if (this.sourceProps && this.sourceProps.serviceObjectId) {
        serviceObjectId = this.sourceProps.serviceObjectId
      } else if (this.multipleCreateServiceObjectIds && this.multipleCreateServiceObjectIds.length >= 1) {
        serviceObjectId = this.multipleCreateServiceObjectIds[0]
      }
      if (serviceObjectId) {
        url += '?serviceObjectId=' + serviceObjectId
      }

      return axiosGet({
        url: url,
        onSuccess: (response) => {
          return response.data.result
        }
      })
    },
    getMetroCameras: function () {
      let url = '/service/delta/serviceobject/search?fields=cameraMetro&formId=serviceObjectMaintenanceNote'
      if (this.sourceProps && this.sourceProps.serviceObjectId) {
        url += '&ids=' + this.sourceProps.serviceObjectId
      }
      return axiosGet({
        url: url,
        onSuccess: (response) => {
          return response.data.result[0].camerasMetro
        }
      })
    }
  }
}

